import styled from "styled-components";
import { IBaseBtn } from "./interfaces";

const Container = styled.div<IBaseBtn>`
    display: inline-flex;
    align-items: center;
    padding: 6px;
    border: 1px solid black;
    cursor: pointer;
    max-height: 20%;

    pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const BaseButton: React.FC<IBaseBtn> = ({
    Icon,
    title,
    style,
    onClick,
    disabled,
}) => {
    return (
        <Container
            onClick={() => {
                onClick && onClick();
            }}
            style={style}
            disabled={disabled}
        >
            {Icon && <Icon style={{ padding: 2 }} />}
            {title && <span>{title}</span>}
        </Container>
    );
};

export default BaseButton;
